"use client";

import React, { useState, useMemo } from "react";
import { ArrowUpRight, Building2, MapPin, Search } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
interface DestinationItem {
  id: number;
  city: string;
  path: string;
  region: string;
}
const destinations: DestinationItem[] = [{
  id: 1,
  city: "Goa",
  path: "/HotelRevenueManagementInGoaPage",
  region: "West"
}, {
  id: 2,
  city: "Jaipur",
  path: "/HotelRevenueManagementInJaipurPage",
  region: "North"
}, {
  id: 3,
  city: "Delhi",
  path: "/HotelRevenueManagementInDelhiPage",
  region: "North"
}, {
  id: 4,
  city: "Mumbai",
  path: "/HotelRevenueManagementInMumbaiPage",
  region: "West"
}, {
  id: 5,
  city: "Puri",
  path: "/HotelRevenueManagementInPuriPage",
  region: "East"
}, {
  id: 6,
  city: "Udaipur",
  path: "/HotelRevenueManagementInUdaipurPage",
  region: "North"
}, {
  id: 7,
  city: "Shimla",
  path: "/HotelRevenueManagementInShimlaPage",
  region: "North"
}, {
  id: 8,
  city: "Mahabaleshwar",
  path: "/HotelRevenueManagementInMahabaleshwarPage",
  region: "West"
}, {
  id: 9,
  city: "Mussoorie",
  path: "/HotelRevenueManagementInMussooriePage",
  region: "North"
}, {
  id: 10,
  city: "Rishikesh",
  path: "/HotelRevenueManagementInRishikeshPage",
  region: "North"
}, {
  id: 11,
  city: "Bangalore",
  path: "/HotelRevenueManagementInBangalorePage",
  region: "South"
}, {
  id: 12,
  city: "Pondicherry",
  path: "/HotelRevenueManagementInPondicherryPage",
  region: "South"
}, {
  id: 13,
  city: "Ooty",
  path: "/HotelRevenueManagementInOotyPage",
  region: "South"
}, {
  id: 14,
  city: "Mysore",
  path: "/HotelRevenueManagementInMysorePage",
  region: "South"
}, {
  id: 15,
  city: "Manali",
  path: "/HotelRevenueManagementInManaliPage",
  region: "North"
}, {
  id: 16,
  city: "Nainital",
  path: "/HotelRevenueManagementInNainitalPage",
  region: "North"
}, {
  id: 17,
  city: "Lonavala",
  path: "/HotelRevenueManagementInLonavalaPage",
  region: "West"
}, {
  id: 18,
  city: "Hyderabad",
  path: "/HotelRevenueManagementInHyderabadPage",
  region: "South"
}, {
  id: 19,
  city: "Varanasi",
  path: "/HotelRevenueManagementInVaranasiPage",
  region: "North"
}, {
  id: 20,
  city: "Digha",
  path: "/HotelRevenueManagementInDighaPage",
  region: "East"
}, {
  id: 21,
  city: "Chandigarh",
  path: "/HotelRevenueManagementInChandigarhPage",
  region: "North"
}, {
  id: 22,
  city: "Mount Abu",
  path: "/HotelRevenueManagementInMountAbuPage",
  region: "North"
}, {
  id: 23,
  city: "Darjeeling",
  path: "/HotelRevenueManagementInDarjeelingPage",
  region: "East"
}, {
  id: 24,
  city: "Ahmedabad",
  path: "/HotelRevenueManagementInAhmedabadPage",
  region: "West"
}, {
  id: 25,
  city: "Pune",
  path: "/HotelRevenueManagementInPunePage",
  region: "West"
}, {
  id: 26,
  city: "Vrindavan",
  path: "/HotelRevenueManagementInVrindavanPage",
  region: "North"
}, {
  id: 27,
  city: "Agra",
  path: "/HotelRevenueManagementInAgraPage",
  region: "North"
}, {
  id: 28,
  city: "Amritsar",
  path: "/HotelRevenueManagementInAmritsarPage",
  region: "North"
}, {
  id: 29,
  city: "Matheran",
  path: "/HotelRevenueManagementInMatheranPage",
  region: "West"
}, {
  id: 30,
  city: "Haridwar",
  path: "/HotelRevenueManagementInHaridwarPage",
  region: "North"
}, {
  id: 31,
  city: "Chennai",
  path: "/HotelRevenueManagementInChennaiPage",
  region: "South"
}, {
  id: 32,
  city: "Tirupati",
  path: "/HotelRevenueManagementInTirupatiPage",
  region: "South"
}, {
  id: 33,
  city: "Kolkata",
  path: "/HotelRevenueManagementInKolkataPage",
  region: "East"
}, {
  id: 34,
  city: "Munnar",
  path: "/HotelRevenueManagementInMunnarPage",
  region: "South"
}, {
  id: 35,
  city: "Indore",
  path: "/HotelRevenueManagementInIndorePage",
  region: "Central"
}, {
  id: 36,
  city: "Gurgaon",
  path: "/HotelRevenueManagementInGurgaonPage",
  region: "North"
}, {
  id: 37,
  city: "Jodhpur",
  path: "/HotelRevenueManagementInJodhpurPage",
  region: "North"
}, {
  id: 38,
  city: "Gulmarg",
  path: "/HotelRevenueManagementInGulmargPage",
  region: "North"
}, {
  id: 39,
  city: "Srinagar",
  path: "/HotelRevenueManagementInSrinagarPage",
  region: "North"
}, {
  id: 40,
  city: "Dehradun",
  path: "/HotelRevenueManagementInDehradunPage",
  region: "North"
}, {
  id: 41,
  city: "Shirdi",
  path: "/HotelRevenueManagementInShirdiPage",
  region: "West"
}, {
  id: 42,
  city: "Ujjain",
  path: "/HotelRevenueManagementInUjjainPage",
  region: "Central"
}, {
  id: 43,
  city: "Alibag",
  path: "/HotelRevenueManagementInAlibagPage",
  region: "West"
}, {
  id: 44,
  city: "Lucknow",
  path: "/HotelRevenueManagementInLucknowPage",
  region: "North"
}, {
  id: 45,
  city: "Madurai",
  path: "/HotelRevenueManagementInMaduraiPage",
  region: "South"
}, {
  id: 46,
  city: "Dwarka",
  path: "/HotelRevenueManagementInDwarkaPage",
  region: "West"
}];
export default function WorkDirectory() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("All");
  const prefersReducedMotion = useReducedMotion();
  const regions = ["All", "North", "South", "West", "East", "Central"];
  const filteredDestinations = useMemo(() => {
    return destinations.filter(dest => {
      const matchesSearch = dest.city.toLowerCase().includes(searchQuery.trim().toLowerCase());
      const matchesRegion = selectedRegion === "All" || dest.region === selectedRegion;
      return matchesSearch && matchesRegion;
    });
  }, [searchQuery, selectedRegion]);
  return <section id="whereweworkdirectory" data-nav="light" className="bg-background text-foreground py-20 lg:py-28 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header with visual */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center mb-12">
          <div className="lg:col-span-7">
            <Badge variant="outline" className="mb-4 border-secondary/40 text-secondary-foreground bg-accent/40 px-3 py-1 font-sans text-xs tracking-wider uppercase">
              Regional Coverage
            </Badge>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-foreground tracking-tight mb-4">
              Where we work
            </h1>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed font-sans">
              HotelRevBaBa provides hotel revenue management and OTA consulting
              across these Indian destinations.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-lg border border-border bg-card shadow-xs">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotelrevbaba_india_coverage_map.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotelrevbaba_india_coverage_map.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotelrevbaba_india_coverage_map.png-wvc-sizes" alt="HotelRevBaBa hotel revenue management and OTA optimization service coverage across hospitality destinations in India" loading="lazy" decoding="async" className="w-full h-48 sm:h-56 object-cover" />
            </div>
          </div>
        </div>

        {/* Filter and Search Bar */}
        <div className="mb-10 flex flex-col md:flex-row gap-4 items-stretch md:items-center justify-between bg-card p-4 rounded-xl border border-border shadow-xs">
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 size-4 text-muted-foreground pointer-events-none" />
            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search destination..." className="w-full pl-10 pr-4 py-2 text-sm bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-transparent transition-shadow" />
          </div>

          {/* Region Tabs */}
          <div className="flex items-center gap-1.5 overflow-x-auto pb-1 md:pb-0 scrollbar-none">
            {regions.map((region, rIdx) => {
            const isActive = selectedRegion === region;
            return <button key={region} data-index={rIdx} type="button" onClick={() => setSelectedRegion(region)} className={`px-3 py-1.5 text-xs sm:text-sm font-medium rounded-full whitespace-nowrap transition-[color,background-color] ${isActive ? "bg-primary text-primary-foreground shadow-xs" : "bg-muted text-muted-foreground hover:bg-accent hover:text-accent-foreground"}`}>
                  {region}
                </button>;
          })}
          </div>
        </div>

        {/* Destination Cards Grid */}
        {filteredDestinations.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filteredDestinations.map((dest, i) => {
          return <div key={dest.id} data-index={i}>
                  <motion.div initial={prefersReducedMotion ? false : {
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.35,
              delay: prefersReducedMotion ? 0 : Math.min(i * 0.02, 0.3),
              ease: "easeOut"
            }} className="h-full">
                    <Link to={dest.path} className="group flex flex-col justify-between h-full p-4 sm:p-5 rounded-xl bg-card border border-border shadow-xs hover:border-secondary hover:shadow-md transition-[border-color,box-shadow,background-color] bg-card/60 hover:bg-card relative overflow-hidden">
                      <div className="flex items-start justify-between gap-3 mb-3">
                        <div className="size-9 rounded-md bg-accent/60 flex items-center justify-center text-secondary shrink-0 group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors">
                          <MapPin className="size-4" />
                        </div>
                        <span className="text-[11px] font-mono text-muted-foreground uppercase tracking-wider bg-muted px-2 py-0.5 rounded">
                          {dest.region}
                        </span>
                      </div>

                      <div className="space-y-1">
                        <p className="text-xs font-mono text-muted-foreground">
                          OTA &amp; Yield Strategy
                        </p>
                        <h3 className="text-sm sm:text-base font-semibold text-foreground group-hover:text-primary transition-colors flex items-center justify-between gap-2">
                          <span>{`Hotel Revenue Management in ${dest.city}`}</span>
                          <ArrowUpRight className="size-4 text-muted-foreground opacity-60 group-hover:opacity-100 group-hover:text-secondary group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-[transform,color,opacity] shrink-0" />
                        </h3>
                      </div>
                    </Link>
                  </motion.div>
                </div>;
        })}
          </div> : <div className="text-center py-16 bg-card rounded-xl border border-dashed border-border p-8">
            <Building2 className="size-10 text-muted-foreground mx-auto mb-3 opacity-60" />
            <h3 className="text-lg font-semibold text-foreground mb-1">
              No matching destinations found
            </h3>
            <p className="text-sm text-muted-foreground">
              Try searching for a different city or resetting the region filter.
            </p>
          </div>}

        {/* Bottom Context Note */}
        <div className="mt-14 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p className="font-sans">
            Consultancy and revenue management operations led by Sunil Singh across 46 major Indian hospitality markets.
          </p>
          <span className="font-mono text-secondary-foreground bg-accent px-3 py-1 rounded-sm">
            {`${destinations.length} Active Markets`}
          </span>
        </div>
      </div>
    </section>;
}